<template>
    <div>
        <template v-if="crud_employee === true && crud_employee !==null && getDefault===true">
            <form id="employeeForm" @submit.prevent="addEmployeePayment">
                <div class="page-top mb-1 mb-3 clearfix">
                    <h1 class="float-left"> Add Employee </h1>
                    <button class="btn btn-primary float-right submit_form" :disabled="disable_btn">Next</button>
                    <router-link to="/employees" class="btn btn-primary float-right mr-1"> Cancel </router-link>
                </div>
                <div class="peopple-managment-main">
                    <ul class="page-status">
                        <li class="page-status-list done">
                            <span class="status-highlighter">1</span>
                            Personal Details
                        </li>
                        <li class="page-status-list done">
                            <span class="status-highlighter">2</span>
                            Job Details
                        </li>
                        <li class="page-status-list done">
                            <span class="status-highlighter">3</span>
                            Tax Details
                        </li>
                        <li class="page-status-list active">
                            <span class="status-highlighter">4</span>
                            Payment Details
                        </li>
                        <li class="page-status-list">
                            <span class="status-highlighter">5</span>
                            Time Off
                        </li>
                        <li class="page-status-list">
                            <span class="status-highlighter">6</span>
                            User Permission
                        </li>
                        <li class="page-status-list">
                            <span class="status-highlighter">7</span>
                            Welcome Options
                        </li>
                    </ul>
                    <div class="people-management-inner-content p-5">
                        <div class="row">

                            <easyPaisaBeneficiaryComponent v-if="$global.user_company_payment_engine == 'EASY_PAISA'" :form="form" :banks="banks" :getEmployeeWalletDetail="getEmployeeWalletDetail" :addEmployeePaymentDetail="addEmployeePaymentDetail" :changeAccountDetail="changeAccountDetail" :editMode="editMode"/>
                            <fincaBeneficiaryComponent v-if="$global.user_company_payment_engine == 'FINCA'" :form="form" :banks="banks" :getEmployeeWalletDetail="getEmployeeWalletDetail" :addEmployeePaymentDetail="addEmployeePaymentDetail" :changeAccountDetail="changeAccountDetail" :editMode="editMode"/>
                            <meezanBeneficiaryComponent v-if="$global.user_company_payment_engine == 'MEEZAN'" :form="form" :banks="banks" :getEmployeeWalletDetail="getEmployeeWalletDetail" :addEmployeePaymentDetail="addEmployeePaymentDetail" :changeAccountDetail="changeAccountDetail" :editMode="editMode"/>
                            <nbpFundsBeneficiaryComponent v-if="$global.user_company_payment_engine == 'NBP_FUND'" :form="form" :banks="banks" :getEmployeeWalletDetail="getEmployeeWalletDetail" :addEmployeePaymentDetail="addEmployeePaymentDetail" :changeAccountDetail="changeAccountDetail" :editMode="editMode"/>
                            <faysalBeneficiaryComponent v-if="$global.user_company_payment_engine == 'FAYSAL'" :form="form" :banks="banks" :getEmployeeWalletDetail="getEmployeeWalletDetail" :addEmployeePaymentDetail="addEmployeePaymentDetail" :changeAccountDetail="changeAccountDetail" :editMode="editMode"/>
                            <emoneyBeneficiaryComponent v-if="$global.user_company_payment_engine == 'EMONEY'" :form="form" :banks="banks" :getEmployeeWalletDetail="getEmployeeWalletDetail" :addEmployeePaymentDetail="addEmployeePaymentDetail" :changeAccountDetail="changeAccountDetail" :editMode="editMode"/>
                        </div>
                        <div class="fetched-save-detail mt-5 w-100" v-if="beneficiaries.length > 0">
                            <table>
                                <thead>
                                    <tr>
                                        <th> Payment Type </th>
                                        <th> Account Title </th>
                                        <th> Account Number </th>
                                        <th> Bank Name </th>
                                        <th> Default </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="beneficiary in beneficiaries"
                                            v-bind:key="beneficiary.id"
                                            v-bind:value="beneficiary.id">
                                        <td> {{ beneficiary.account_type }} </td>
                                        <td> {{ beneficiary.account_title }} </td>
                                        <td> {{ beneficiary.account_number }} </td>
                                        <td> {{ beneficiary.bank_name }} </td>
                                        <td>
                                            <a href="javascript:void(0);" @click="makeDefault(beneficiary.id)" v-if="beneficiary.is_default == 'NO'">Mark Default</a>
                                            <a v-if="beneficiary.is_default == 'YES'">Default <i class="fa fa-check-circle" style="font-size:18px;color:green"></i></a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </form>
        </template>
        <template v-else-if="crud_employee === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="crud_employee === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    import easyPaisaBeneficiaryComponent from '../partial/easyPaisaBeneficiaryComponent.vue';
    import meezanBeneficiaryComponent from '../partial/meezanBeneficiaryComponent.vue';
    import fincaBeneficiaryComponent from '../partial/fincaBeneficiaryComponent.vue';
    import nbpFundsBeneficiaryComponent from '../partial/nbpFundsBeneficiaryComponent';
    import faysalBeneficiaryComponent from '../partial/faysalBeneficiaryComponent';
    import emoneyBeneficiaryComponent from '../partial/emoneyBeneficiaryComponent';
    export default {
        components: {
            easyPaisaBeneficiaryComponent,
            meezanBeneficiaryComponent,
            fincaBeneficiaryComponent,
            nbpFundsBeneficiaryComponent,
            faysalBeneficiaryComponent,
            emoneyBeneficiaryComponent
        },
        data() {
            return {
                editMode : 'NO',
                form: new Form({
                    accountType : '',
                    bank : '',
                    accountNumber : '',
                    cnic : '',
                    is_default : '',
                    paymentMethod : '',
                    account_detail : false,
                    account_information : {
                        customer_name : '',
                        account_number : '',
                        bank_name : '',
                    },
                    id : this.$route.params.id
                }),
                make_default : new Form({
                    id : '',
                    uid: this.$route.params.id
                }),
                beneficiaries: '',
                mobileNumber: '',
                showNextButton : false,
                banks: null,
                getDefault: null,
                crud_employee: null,
                disable_btn: false,
            }
        },
        methods: {
            addEmployeePayment(){
                this.$Progress.start();
                axios.post('/api/updateEmployeePaymentDetail/'+this.form.id)
                .then(res => {
                    if(res.status == 200){
                        if(res.data.status == 409){
                            this.showAlertBox('error',res.data.msg);
                        }else{
                            this.showToastBox('success','Employee payment detail added successfully');
                            this.$Progress.finish();
                            this.$router.push('/addEmployeeTimeoff/'+this.form.id);
                        }
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load data');
                    }
                })
                .catch(err => {
                    console.log(err);
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load data');
                });
            },
            makeDefault(id){
                this.$Progress.start();
                this.make_default.id = id;
                this.make_default.post('/api/makeEmployeeDefaultBeneficiary')
                .then(res => {
                    if (res.status == 200) {
                        this.getDefaultWallet();
                        this.$Progress.finish();
                        this.showToastBox('success','Account number set to default successfully');
                    } else {
                        this.$Progress.fail();
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load data');
                });
            },
            changeAccountDetail(){
                this.form.account_detail = false;
            },
            addEmployeePaymentDetail() {
                this.$Progress.start();
                this.form.post('/api/addEmployeePaymentDetail/'+this.form.id)
                .then(res => {
                    if(res.status == 200){
                        if(res.data.status == 200){
                            this.$Progress.finish();
                            this.getDefaultWallet();
                            this.showToastBox('success','Employee beneficiary added successfully');
                            $(".submit_form").prop('disabled',false);
                        }else if(res.data.status == 409){
                            this.$Progress.fail();
                            this.showAlertBox('error',res.data.msg);
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','Some problem in your form data');
                        }
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Some problem in your form data');
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data');
                });
            },
            getEmployeeWalletDetail(){
                this.$Progress.start();
                if(this.form.paymentMethod == 'BANK' && this.$global.user_company_payment_engine =='MEEZAN'){
                    var accNo = this.form.accountNumber;
                    if (accNo.length < 14 || accNo.length > 24) {
                        this.$Progress.fail();
                        this.showAlertBox('error','Account number must be in between 14 to 24 digits');
                        return false;
                    }
                }
                if(this.form.paymentMethod == 'IBFT' && this.$global.user_company_payment_engine =='MEEZAN'){
                    var accNo = this.form.accountNumber;
                    if (accNo.length > 24) {
                        this.$Progress.fail();
                        this.showAlertBox('error','Account number must be 24 digits');
                        return false;
                    }
                }
                this.form.post('/api/getEmployeeWalletDetail')
                .then(res => {
                    if(res.data.code == 200){
                        this.form.account_detail = this.form.accountType;
                        this.form.account_information.customer_name = res.data.data.accountTitle;
                        this.form.account_information.account_number = this.form.accountNumber;
                        if(this.form.accountType == 'IBFT'){
                            this.form.account_information.bank_name = this.form.bank.bank_name;
                            this.form.account_information.bank_code = this.form.bank.bank_code;
                        }
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error',res.data.msg);
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load data');
                });
            },
            getDefaultWallet(){
                var uid = this.$route.params.id;
                this.$Progress.start();
                axios.post('/api/getEmployeeDefaultWallet', {
                    uid: uid
                })
                .then(res => {
                    if(res.status == 200){
                        if(res.data.page_view == false){
                            this.crud_employee = false;
                        }else if(res.data.page_view == true){
                            // @hamza - why it is mobile num ??
    		                this.form.accountNumber = res.data.mobile_no;
	    	                this.form.cnic = res.data.cnic;
                            this.beneficiaries = res.data.beneficiaries;
                            if(this.beneficiaries.length == 0){
                                this.form.is_default = 'YES';
                                this.disable_btn = true;
                            }else{
                                this.form.is_default = 'NO';
                                this.disable_btn = false;
                            }
                            this.showWalletDetail = false;
                        }
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load data');
                    }
                    this.getDefault = true;
                })
                .then(res=>{
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load data');
                });
            },
            getBankList(){
                this.$Progress.start();
                axios.get('/api/ibftBankList')
                .then(res => {
                    if(res.status == 200){
                        if(res.data.bankList != null){
                            this.banks = res.data.bankList;
                        }
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load data');
                    }
                })
                .then(res=>{
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                .catch(err => {
                    console.log(err);
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load data');
                });
            },
            getEmployeeData() {
                axios.get('/api/editEmployee/'+this.$route.params.id)
                .then(res => {
                    if(res.status == 200){
                        if(res.data.page_view == false){
                            this.crud_employee = false;
                        }else if(res.data.page_view == true){
                            if(res.data.user.wizard_cycle == 0){
                                this.$router.push('/addEmployeePersonalDetail/'+this.$route.params.id);
                            }else if(res.data.user.wizard_cycle == 1){
                                this.$router.push('/addEmployeeBasicDetail/'+this.$route.params.id);
                            }else if(res.data.user.wizard_cycle == 2){
                                this.$router.push('/addEmployeeTaxDetail/'+this.$route.params.id);
                            }else if(res.data.user.wizard_cycle == 3){
                                this.getDefaultWallet();
                                this.getBankList();
                            }else if(res.data.user.wizard_cycle == 4){
                                this.$router.push('/addEmployeeTimeoff/'+this.$route.params.id);
                            }else if(res.data.user.wizard_cycle == 5){
                                this.$router.push('/addEmployeeUserPermission/'+this.$route.params.id);
                            }else if(res.data.user.wizard_cycle == 6){
                                this.$router.push('/addEmployeeWelcome/'+this.$route.params.id);
                            }
                        }
                    }else{
                        this.showAlertBox('error','Error to load data');
                    }
                })
                .catch(err => {
                    this.showAlertBox('error','Error to load data');
                });
            },
        },
        mounted() {
            this.$Progress.start();
            this.can('crud_employee').then(result => {
                this.crud_employee = result.crud_employee;
            }).then(result => {
                if(this.crud_employee == true){
                    if(this.$global.user_company_payment_engine == 'FINCA'){
                        this.form.paymentMethod = this.form.accountType = 'SIMSIM';
                    }else if(this.$global.user_company_payment_engine == 'MEEZAN'){
                        this.form.paymentMethod = this.form.accountType = 'EMONEY';
                    }else if(this.$global.user_company_payment_engine == 'EASY_PAISA'){
                        this.form.paymentMethod = this.form.accountType = 'EASY_PAISA_WALLET';
                    }else if(this.$global.user_company_payment_engine == 'NBP_FUND'){
                        this.form.paymentMethod = this.form.accountType = 'IBFT';
                    }else if(this.$global.user_company_payment_engine == 'FAYSAL'){
                        this.form.paymentMethod = this.form.accountType = 'BANK';
                    }
                    this.getEmployeeData();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });
        }
    }
</script>
